import React, { Component } from 'react'
import { createPortal } from 'react-dom'
import { connect } from 'react-redux'
import { Route, withRouter, Redirect, Switch } from 'react-router'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'
import Loader from 'components/loader/loader'
import {
	getProject,
	getProjectFiles,
	removeProjectSlug,
	openModal
} from 'state/actions'

import {
	getCurrentUser,
	getUserRoles,
	getProjectSelector,
	isPremium,
} from 'state/selectors'

import ProjectIndex from './project-index'

import SingleTask from './project-tasks/single-task/single-task'
import SingleTaskPortal from './project-tasks/single-task/single-task-portal'

import {
	isMobile,
	getApplicableUsers
} from 'utils'

import isEqual from 'react-fast-compare'

class Project extends Component {
	state = {
		projectScrollHeight: 0,
		projectFolderChain: [],
		isLoading: false,
		applicableUsers: []
	}

	isLoading = false
	loadingSlug = ''
	tempProjectData = null

	componentWillMount() {
		this.trygetProject(this.props.match.params.project_slug)

		this.getApplicableUsers()
	}

	componentWillUnmount() {
		this.props.removeProjectSlug()
	}

	shouldComponentUpdate = nextProps => {
		if (this.props.activeHeaderTab !== nextProps.activeHeaderTab) {
			return false
		}

		if (this.props.chatBehaviourTrigger !== nextProps.chatBehaviourTrigger) {
			return false
		}

		return true
	}

	trygetProject = (slug, causedByHardSet) => {
		const {
			currentAccount,
			history,
			openModal,
			getProject,
			getProjectFiles
		} = this.props

		if (!currentAccount) {
			return
		}

		this.setState({
			isLoading: true
		})

		this.isLoading = true

		this.loadingSlug = slug

		getProject(slug, (project, error) => {
			this.loadingSlug = ''
			this.isLoading = false

			this.setState({
				isLoading: false
			})

			if (error) {
				history.push('/' + currentAccount.slug + '/projects')

				openModal('error', null, { message: 'This project couldn\'t be opened.' })
			} else {
				getProjectFiles(slug)
			}
		})
	}

	setProjectScrollHeight = projectScrollHeight => {
		this.setState({
			projectScrollHeight
		})
	}

	componentDidUpdate = prevProps => {
		if (!prevProps.hasHardSetState && this.props.hasHardSetState) {
			return this.trygetProject(this.props.match.params.project_slug, true)
		}

		this.getApplicableUsers()

		setTimeout(_ => {
			const oldSlug = prevProps.match.params.project_slug
			const newSlug = this.props.match.params.project_slug

			const oldId = prevProps.currentProject ? prevProps.currentProject.id : null
			const newId = this.props.currentProject ? this.props.currentProject.id : null

			const isSlugUnequal = oldSlug !== newSlug
			const isIdUnequal = oldId !== newId

			if ((isSlugUnequal && this.loadingSlug != newSlug) || (isIdUnequal && !this.isLoading)) {
				this.setProjectScrollHeight(0)

				this.trygetProject(this.props.match.params.project_slug)
			}
		}, 1)
	}

	getApplicableUsers = _ => {
		const {
			currentAccount,
			allUsers,
			currentProject,
			allTeams,
		} = this.props

		const users = getApplicableUsers(currentAccount, allUsers, currentProject, allTeams)

		if (!isEqual(this.state.applicableUsers, users)) {
			this.setState({
				applicableUsers: users
			})
		}
	}

	canAccessProject = _ => {
		const {
			currentProject,
			allTeams,
			userData,
			userRoles,
			isPremium
		} = this.props

		let canAccess = false

		if (currentProject) {
			if (!currentProject.guestIds) {
				// Hasn't loaded yet, or legacy from cache somehow.
				return true
			}

			if (currentProject.guestIds && currentProject.guestIds.indexOf(userData.id) !== -1) {
				canAccess = true
			}

			if (userRoles.admin || userRoles.pm || (!isPremium && !userRoles.guest)) {
				canAccess = true
			} else if (!userRoles.guest) {
				if (currentProject.is_public || !isPremium) {
					canAccess = true
				}

				currentProject.teamIds && allTeams && currentProject.teamIds.forEach(teamId => {
					const team = allTeams[teamId]

					if (team.userIds.indexOf(userData.id) !== -1) {
						canAccess = true
					}
				})
			}
		}

		return canAccess
	}

	updateProjectFolderChain = projectFolderChain => {
		this.setState({
			projectFolderChain
		})
	}

	canEditProject = _ => {
		const {
			userData,
			currentProject,
			userRoles
		} = this.props

		if (!currentProject) {
			return false
		}

		if (userRoles.pm || userRoles.admin) {
			return true
		}

		if (currentProject.created_by && currentProject.created_by == userData.id) {
			return true
		}
	}

	isLoadingOtherAccount = _ => {
		const {
			location,
			currentAccount
		} = this.props

		const accountSlug = location.pathname.split('/')[1]

		return currentAccount && currentAccount.slug !== accountSlug
	}

	goBack = _ => {
		const {
			location,
			history
		} = this.props

		let tempUrl = location.pathname
		let to = tempUrl.lastIndexOf('/')

		to = to == -1 ? tempUrl.length : to + 1

		tempUrl = tempUrl.substring(0, to)

		history.push(tempUrl)
	}

	render() {
		const {
			hasHardSetState,
			location,
			currentProject,
			match,
			currentAccount,
			userRoles,
			activeHeaderTab,
			isPremium
		} = this.props

		const {
			isLoading,
			projectFolderChain,
			applicableUsers,
		} = this.state

		const canEditProject = this.canEditProject()

		const {
			projectScrollHeight
		} = this.state

		const showLoader = this.isLoadingOtherAccount()

		if (!this.canAccessProject() && !showLoader) {
			const projectsUrl = match.path.replace('/:project_slug', '')

			return (
				<Redirect to={projectsUrl} />
			)
		}

		const _isMobile = isMobile()
		const Element = _isMobile ? Switch : SwitchCSSTransitionGroup

		const singleTaskIdIfExists = (() => {
			const { pathname } = location
			const { url } = match

			if (~pathname.indexOf('/tasks/')) {
				const _taskId = pathname.replace(url + '/tasks/', '')

				if (_taskId) {
					return parseInt(_taskId)
				}
			}

			return false
		})()

		return (
			<div className="page-container">
				<div className="loader-container">
					{showLoader ?
						<Loader visible={showLoader} />
						: null
					}
				</div>
				<div className={showLoader ? "page-container-inner faded" : "page-container-inner"}>
					{currentProject ?
						<React.Fragment>
							{(!_isMobile && singleTaskIdIfExists) ?
								<SingleTaskPortal
									project={currentProject}
									applicableUsers={applicableUsers}
									taskId={singleTaskIdIfExists}
								/>
								: null}
							<Element
								location={location}
								transitionName="zoom"
								transitionEnterTimeout={10}
								transitionLeaveTimeout={10}
							>
								{_isMobile ?
									<Route path={match.url + "/tasks/:task_id"} key={'none'} render={params => {
										return (
											<div>
												<SingleTask
													{...params}
													currentProject={currentProject}
													currentAccount={currentAccount}
													applicableUsers={applicableUsers}
													taskId={parseInt(params.match.params.task_id)}
												/>
											</div>
										)
									}} key={'none'} />
									: null}
								<Route slug={this.props.match.params.project_slug} path={match.url + "/"} render={params => (
									<ProjectIndex
										{...params}
										projectScrollHeight={projectScrollHeight}
										setProjectScrollHeight={this.setProjectScrollHeight}
										hasHardSetState={hasHardSetState}
										canEditProject={canEditProject}
										currentProject={currentProject}
										currentAccount={currentAccount}
										loading={isLoading}
										slug={match.params.project_slug}
										applicableUsers={applicableUsers}
										activeHeaderTab={activeHeaderTab}
										isPremium={isPremium}
										userRoles={userRoles}
										projectFolderChain={projectFolderChain}
										updateProjectFolderChain={this.updateProjectFolderChain}
									/>
								)} key={'none'} />
							</Element>
						</React.Fragment>
						: null}
				</div>
			</div>
		);
	}
}


const mapStateToProps = (state, ownProps) => {
	return {
		hasHardSetState: state.account.hasHardSetState,
		allProjects: state.account.entities.projects,
		allUsers: state.account.entities.users,
		allTeams: state.account.entities.teams,
		currentProjectId: state.account.currentProjectId,
		currentProject: getProjectSelector(state, ownProps),
		userRoles: getUserRoles(state),
		activeHeaderTab: state.account.activeHeaderTab,
		userData: getCurrentUser(state),
		isPremium: isPremium(state),
		chatBehaviourTrigger: state.account.chatBehaviourTrigger
	}
}

export default withRouter(connect(mapStateToProps, { getProject, getProjectFiles, removeProjectSlug, openModal })(Project))


// WEBPACK FOOTER //
// ./src/sections/projects/project/project.jsx